// shared.module.ts
import { NgModule } from '@angular/core';
import { CurrencyFormatPipe } from './currency.pipe';
import { NumberFormatPipe } from './number.pipe';

@NgModule({
  declarations: [CurrencyFormatPipe, NumberFormatPipe],
  exports: [CurrencyFormatPipe, NumberFormatPipe],
})
export class PipeModule { }